import React, { useCallback, useState } from "react";
import { CircularProgress, Grid, Paper, Switch, TextField } from "@material-ui/core";
import { expenseResultField } from "../../constants";
import { handleKeyDown } from "../../common/common";
import MomentUtils from "@date-io/moment";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import SplitHireModal from "./SplitHireModal";
import moment from "moment";
import { tagsByCharAPI } from "../../containers/User/Orders/actions";
import { debounce } from "lodash";
import { Autocomplete } from "@material-ui/lab";
import { fmt3 } from "../../utils";

function VesselVesselReDeliveryIn(props) {
  const {
    selectedVessels = {},
    onChangeSelectedVessel = () => { },
    openSplitHireModal = () => { },
    calculatorData = {},
    setCalculatorData = () => { },
    isFromSingleVesselCalcy = false,
    addNewSplitHire = () => { },
    onChangeSplitHire = () => { },
    isOverride = false,
    setIsOverride,
    label = "",
    isFromVesselVessel,
    onClickEditVesselContract = () => { },

  } = props || {};

  const { clientQuery = {}, portOperation = [] } = calculatorData || {};
  const { Tag3 = {}, Tag4 = {}, } = clientQuery
  const [TagsOptions, setTagsOptions] = useState([]);
  const [tagsLoading, setTagsLoading] = useState(false);

  const onChangeQueryValues = (e) => {
    const { name = "", value = "" } = e.target;
    let newPortOperation = [...portOperation];
    if (name === "freightIdea") {
      newPortOperation = newPortOperation.map((item) => {
        if (item.operation === "Loading") {
          return { ...item, freight: Number(value) };
        }
        return item;
      });
    }
    setCalculatorData({
      ...calculatorData,
      clientQuery: {
        ...clientQuery,
        [name]: Number(value),
      },
      portOperation: newPortOperation,
    });
  };
  const onSelectTags = (value, name) => {
    setCalculatorData({
      ...calculatorData,
      clientQuery: {
        ...clientQuery,
        [name]: value,
      },
    });
    setTagsOptions([])
  };

  const onSearchTagsList = (value, type, name) => {
    if (value) {
      setTagsLoading(name);
      tagsByCharAPI(value, type)
        .then((res) => {
          setTagsLoading(false);
          let tagsList = [];
          if (res.data.list?.length > 0) {
            if (type === "individual") {
              tagsList = res.data.list.map((item) => ({
                label: `${item.individual_firstName} (${item?.individual_emailPersonal})`,
                value: item._id,
                name: item.individual_firstName
              }));
            } else {
              tagsList = res.data.list.map((item) => ({
                label: `${item.organisation_fullName} (${item?.organisation_emailOfficial})`,
                value: item._id,
                name: item.organisation_fullName
              }));
            }
          }
          setTagsOptions(tagsList);
        })
        .catch((err) => {
          setTagsLoading(false);
          setTagsOptions([]);
        });
    }
  };

  const debouncedSearch = useCallback(
    debounce((search, type, name) => {
      onSearchTagsList(search, type, name);
    }, 400),
    []
  );

  const delayTagsSearch = (search, type, name) => {
    // setSelectedPort({ ...selectedPort, port: search });
    debouncedSearch(search, type, name);
  };


  const {
    hireGbb = 0,
    hirePerDay = 0,
    tcEq = 0,
    tcAdcom = 0,
    port = "",
    dateOpen,
    DurationOut = 0,
    MinDuration = 0,
    MaxDuration = 0,
    bnkDelhs = 0,
    bnkDells = 0,
    bnkDelmgo = 0,
    bnkPriceDeliveryhs = 0,
    bnkPriceDeliveryls = 0,
    bnkPriceDeliverymgo = 0,
    bnkPriceRedeliveryhs = 0,
    bnkPriceRedeliveryls = 0,
    bnkPriceRedeliverymgo = 0,
    bnkPriceSettlemenths = 0,
    bnkPriceSettlementls = 0,
    bnkPriceSettlementmgo = 0,
    bnkQtyRedeliveryhs = 0,
    bnkQtyRedeliveryls = 0,
    bnkQtyRedeliverymgo = 0,
    bnkRedeliveryQtyTolerancehs = 0,
    bnkRedeliveryQtyTolerancels = 0,
    bnkRedeliveryQtyTolerancemgo = 0,
    miscRevenue = 0,
    revenue = 0,
  } = selectedVessels?.vesselOut || {};
  const deliveryOutPort = portOperation?.find((item) => item?.operation === "Delivery-out");

  // These cells mirror the Delivery-out itinerary row's departure fuel, so edits write back to it.
  const onChangeDeliveryOutFuel = (e) => {
    const { name, value } = e.target;
    setCalculatorData({
      ...calculatorData,
      portOperation: portOperation.map((item) =>
        item === deliveryOutPort ? { ...item, [name]: value } : item
      ),
    });
  };

  return (
    <Grid container>
      <Grid item xs={12} className="calculator-section-header">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: "8px",
          }}
        >
          <>
            <h4 className="result-heading">{label}</h4>
            {isFromVesselVessel && <h3 className="result-heading underline cursor-pointer"
              onClick={() => onClickEditVesselContract('vesselOut')}
            >
              View Contract
            </h3>}
          </>
        </div>
      </Grid>
      <Grid item xs={12}>
        <div>
          <table className="fleet-result-table low-th-width">
            <tbody>
              <tr>
                <th>Port</th>
                <td>
                  <input
                    type="text"
                    value={calculatorData?.portOperation?.filter((itm) => itm?.operation === "Delivery-out")?.[0]?.port || ""}
                    name="port"
                    readOnly
                  />
                </td>
              </tr>
              <tr>
                <th>Date Opening</th>
                <td style={{ paddingRight: "8px" }} className="datepicker-vessel-vessel">
                  <div style={{ paddingRight: "5px", background: "#fff", borderRadius: "3px" }}>
                    {moment(calculatorData?.portOperation?.filter((itm) => itm?.operation === "Redelivery-in")?.[0]?.departureTime).format("MMM Do 'YY HH:mm")}
                  </div>
                </td>
              </tr>
              <tr>
                <th>Duration-Out</th>
                <td>
                  <div className="vessel-duration-field" style={{ display: "flex", alignItems: "center", width: "100%" }}>
                    <input
                      type="number"
                      onKeyDown={handleKeyDown}
                      value={DurationOut || 0}
                      name="DurationOut"
                      style={{ width: 55, background: "#fff", marginRight: "3px" }}
                      onChange={(e) => onChangeSelectedVessel(e, true)}
                    />
                    <span style={{ fontSize: "11px", color: "#334155", marginLeft: "auto", paddingRight: "4px" }}>days</span>
                  </div>
                </td>
              </tr>
              <tr>
                <th>Min Duration</th>
                <td>
                  <div className="vessel-duration-field" style={{ display: "flex", alignItems: "center", width: "100%" }}>
                    <input
                      type="number"
                      onKeyDown={handleKeyDown}
                      value={MinDuration || 0}
                                            name="MinDuration"
                      style={{ width: 55, background: "#fff", marginRight: "3px" }}
                      onChange={(e) => onChangeSelectedVessel(e, true)}
                    />
                    <span style={{ fontSize: "11px", color: "#334155", marginLeft: "auto", paddingRight: "4px" }}>days</span>
                  </div>
                </td>
              </tr>
              <tr>
                <th>Max Duration</th>
                <td>
                  <div className="vessel-duration-field" style={{ display: "flex", alignItems: "center", width: "100%" }}>
                    <input
                      type="number"
                      onKeyDown={handleKeyDown}
                      value={MaxDuration || 0}
                                            name="MaxDuration"
                      style={{ width: 55, background: "#fff", marginRight: "3px" }}
                      onChange={(e) => onChangeSelectedVessel(e, true)}
                    />
                    <span style={{ fontSize: "11px", color: "#334155", marginLeft: "auto", paddingRight: "4px" }}>days</span>
                  </div>
                </td>
              </tr>
              <tr>
                <th
                  className="cursor-pointer underline"
                  onClick={() => openSplitHireModal(selectedVessels)}
                >
                  Hire Per Day
                </th>
                <td>
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    placeholder="0"
                    value={hirePerDay}
                    name="hirePerDay"
                    onChange={(e) => onChangeSelectedVessel(e, true)}
                  />
                </td>
              </tr>
              <tr>
                <th>Hire GBB</th>
                <td>
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    placeholder="0"
                    value={hireGbb}
                    name="hireGbb"
                    onChange={(e) => onChangeSelectedVessel(e, true)}
                  />
                </td>
              </tr>
              <tr>
                <th>TC Eq</th>
                <td>
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    placeholder="0"
                    value={typeof tcEq === "number" ? fmt3(tcEq) : tcEq}
                    name="tcEq"
                    onChange={(e) => onChangeSelectedVessel(e, true)}
                  />
                </td>
              </tr>
              <tr>
                <th>Total Comm(%)</th>
                <td>
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    placeholder="0"
                    value={tcAdcom}
                    name="tcAdcom"
                    onChange={(e) => onChangeSelectedVessel(e, true)}
                  />
                </td>
              </tr>
              <tr>
                <th>Misc Revenue</th>
                <td>
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    placeholder="0"
                    onChange={(e) => onChangeSelectedVessel(e, true)}
                    value={miscRevenue || ""}
                    name="miscRevenue"
                  />
                </td>
              </tr>
              <tr>
                <th>Vsl Extra Expense</th>
                <td>
                  <input
                    type="number"
                    onKeyDown={handleKeyDown}
                    placeholder="0"
                    value={revenue}
                    name="revenue"
                    onChange={(e) => onChangeSelectedVessel(e, true)}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Grid>

      {isFromSingleVesselCalcy ? (
        <Grid item xs={12}>
          <div className="mt-1 flex flex-col gap-1 w-full">
            <div className="w-full">
              <table className="vessel-details-tables bunker-compact w-full has-border-top" style={{ tableLayout: "fixed" }}>
                <thead>
                  <tr>
                    <th style={{ width: "40%", borderTop: "1px solid #cbd5e1", background: "#f1f5f9", color: "#334155", whiteSpace: "nowrap" }}>Bunker Qty</th>
                    <th style={{ width: "20%", borderTop: "1px solid #cbd5e1", background: "#f1f5f9", color: "#334155" }}>Main</th>
                    <th style={{ width: "20%", borderTop: "1px solid #cbd5e1", background: "#f1f5f9", color: "#334155" }}>ECA</th>
                    <th style={{ width: "20%", borderTop: "1px solid #cbd5e1", background: "#f1f5f9", color: "#334155" }}>MGO</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th style={{ background: "#ffffff", padding: "1px 3px", fontSize: "9.5px", fontWeight: "500", whiteSpace: "nowrap" }}>On Delivery</th>
                    <td><input type="number" disabled={!deliveryOutPort} onKeyDown={handleKeyDown} value={deliveryOutPort?.departureHsfo ?? ""} name="departureHsfo" onChange={onChangeDeliveryOutFuel} /></td>
                    <td><input type="number" disabled={!deliveryOutPort} onKeyDown={handleKeyDown} value={deliveryOutPort?.departureLsfo ?? ""} name="departureLsfo" onChange={onChangeDeliveryOutFuel} /></td>
                    <td><input type="number" disabled={!deliveryOutPort} onKeyDown={handleKeyDown} value={deliveryOutPort?.departureMgo ?? ""} name="departureMgo" onChange={onChangeDeliveryOutFuel} /></td>
                  </tr>
                  <tr>
                    <th style={{ background: "#ffffff", padding: "1px 3px", fontSize: "9.5px", fontWeight: "500", whiteSpace: "nowrap" }}>Exp on Re-Del</th>
                    <td><input type="number" onKeyDown={handleKeyDown} value={bnkQtyRedeliveryhs} name="bnkQtyRedeliveryhs" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                    <td><input type="number" onKeyDown={handleKeyDown} value={bnkQtyRedeliveryls} name="bnkQtyRedeliveryls" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                    <td><input type="number" onKeyDown={handleKeyDown} value={bnkQtyRedeliverymgo} name="bnkQtyRedeliverymgo" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                  </tr>
                  <tr>
                    <th style={{ background: "#ffffff", padding: "1px 3px", fontSize: "9.5px", fontWeight: "500", whiteSpace: "nowrap" }}>Tolerance Acc</th>
                    <td><input type="number" onKeyDown={handleKeyDown} value={bnkRedeliveryQtyTolerancehs} name="bnkRedeliveryQtyTolerancehs" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                    <td><input type="number" onKeyDown={handleKeyDown} value={bnkRedeliveryQtyTolerancels} name="bnkRedeliveryQtyTolerancels" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                    <td><input type="number" onKeyDown={handleKeyDown} value={bnkRedeliveryQtyTolerancemgo} name="bnkRedeliveryQtyTolerancemgo" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="w-full">
              <table className="vessel-details-tables bunker-compact w-full has-border-top" style={{ tableLayout: "fixed" }}>
                <thead>
                  <tr>
                    <th style={{ width: "40%", borderTop: "1px solid #cbd5e1", background: "#f1f5f9", color: "#334155", whiteSpace: "nowrap" }}>Bunker Prices</th>
                    <th style={{ width: "20%", borderTop: "1px solid #cbd5e1", background: "#f1f5f9", color: "#334155" }}>Main</th>
                    <th style={{ width: "20%", borderTop: "1px solid #cbd5e1", background: "#f1f5f9", color: "#334155" }}>ECA</th>
                    <th style={{ width: "20%", borderTop: "1px solid #cbd5e1", background: "#f1f5f9", color: "#334155" }}>MGO</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th style={{ background: "#ffffff", padding: "1px 3px", fontSize: "9.5px", fontWeight: "500", whiteSpace: "nowrap" }}>On Delivery</th>
                    <td>{!isOverride ? <p className="m-0 text-[10.5px] px-1">{bnkPriceDeliveryhs}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceDeliveryhs} disabled={!isOverride} name="bnkPriceDeliveryhs" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                    <td>{!isOverride ? <p className="m-0 text-[10.5px] px-1">{bnkPriceDeliveryls}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceDeliveryls} disabled={!isOverride} name="bnkPriceDeliveryls" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                    <td>{!isOverride ? <p className="m-0 text-[10.5px] px-1">{bnkPriceDeliverymgo}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceDeliverymgo} disabled={!isOverride} name="bnkPriceDeliverymgo" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                  </tr>
                  <tr>
                    <th style={{ background: "#ffffff", padding: "1px 3px", fontSize: "9.5px", fontWeight: "500", whiteSpace: "nowrap" }}>On Re-Del</th>
                    <td>{!isOverride ? <p className="m-0 text-[10.5px] px-1">{bnkPriceRedeliveryhs}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceRedeliveryhs} name="bnkPriceRedeliveryhs" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                    <td>{!isOverride ? <p className="m-0 text-[10.5px] px-1">{bnkPriceRedeliveryls}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceRedeliveryls} name="bnkPriceRedeliveryls" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                    <td>{!isOverride ? <p className="m-0 text-[10.5px] px-1">{bnkPriceRedeliverymgo}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceRedeliverymgo} name="bnkPriceRedeliverymgo" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                  </tr>
                  <tr>
                    <th style={{ background: "#ffffff", padding: "1px 3px", fontSize: "9.5px", fontWeight: "500", whiteSpace: "nowrap" }}>For Settlement</th>
                    <td>{!isOverride ? <p className="m-0 text-[10.5px] px-1">{bnkPriceSettlemenths}</p> : <input type="number" onKeyDown={handleKeyDown} value={bnkPriceSettlemenths} name="bnkPriceSettlemenths" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                    <td>{!isOverride ? <p className="m-0 text-[10.5px] px-1">{bnkPriceSettlementls}</p> : <input type="number" onKeyDown={handleKeyDown} value={bnkPriceSettlementls} name="bnkPriceSettlementls" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                    <td>{!isOverride ? <p className="m-0 text-[10.5px] px-1">{bnkPriceSettlementmgo}</p> : <input type="number" onKeyDown={handleKeyDown} value={bnkPriceSettlementmgo} name="bnkPriceSettlementmgo" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Grid>
      ) : ""}
    </Grid>
  );
}

export default VesselVesselReDeliveryIn;
